import {IEventEmitter} from './EventEmitterBase';
import {ArgValidator} from './ArgValidator';

var Map: any = require('es6-map');

export type EventEmitterCachedLogger = (isError: boolean, group: string, message: string, error?: Error) => void;

export class EventEmitterCached implements IEventEmitter {
    private _eventEmitter: IEventEmitter;
    private _cachedEvents: any; //Map<any, Array<any[]>>;
    private _cacheSize: number;
    private _logPrefix: string;
    private _logger: EventEmitterCachedLogger;

    constructor(eventEmitter: IEventEmitter, cacheSize: number, logPrefix: string, logger: EventEmitterCachedLogger) {
        ArgValidator.ensureIsNotNullOrUndefined(eventEmitter, 'eventEmitter');
        ArgValidator.ensureIsNotNullOrUndefined(logPrefix, 'logPrefix');
        ArgValidator.ensureIsNotNullOrUndefined(logger, 'logger');
        ArgValidator.ensureIsNumber(cacheSize, 'cacheSize');
        if (cacheSize <= 0) {
            throw new Error(`Cant create new instance EventEmitterCached, cacheSize must be greater than 0 (and is ${cacheSize})`);
        }

        this._eventEmitter = eventEmitter;
        this._cacheSize = cacheSize;
        this._logPrefix = logPrefix;
        this._logger = logger;
        this._cachedEvents = new Map();
    }

    private fireCachedEvents(event: string | symbol): void {
        if (this._cachedEvents.has(event)) {
            const eventArray = this._cachedEvents.get(event);
            if (eventArray) {
                const cache = eventArray.splice(0);
                this._cachedEvents.delete(event);
                if (cache && cache.length > 0) {
                    const eventType = event.toString();
                    this._logger(false, this._logPrefix, `Going to emit cached listeners(${cache.length}) for event '${eventType}'`);

                    cache.forEach(cachedEventArgs => {
                        try {
                            if (Array.isArray(cachedEventArgs)) {
                                this._eventEmitter.emit(event, ...cachedEventArgs);
                            } else {
                                this._eventEmitter.emit(event, cachedEventArgs);
                            }
                        } catch (err) {
                            this._logger(true, this._logPrefix, `Error when emitting cached listener for event '${eventType}'`, err);
                        }
                    });
                }
            }
        }
    }

    removeListener(event: string | symbol, listener: (...args: any[]) => void): this {
        this._eventEmitter.removeListener(event, listener);
        return this;
    }

    removeAllListeners(event?: string | symbol): this {
        this._eventEmitter.removeAllListeners(event);
        return this;
    }

    emit(event: string | symbol, ...args: Array<any>): boolean {
        const hasListener = this._eventEmitter.emit(event, ...args);

        if (!hasListener) {
            const argsArray = Array.isArray(args) && args.length === 1 ? args[0] : args;

            let eventArray: Array<any[]>;
            if (this._cachedEvents.has(event)) {
                eventArray = this._cachedEvents.get(event);
            } else {
                eventArray = [];
                this._cachedEvents.set(event, eventArray);
            }

            if (eventArray.length <= this._cacheSize) {
                eventArray.push(argsArray);
            }

            const eventType = event.toString();
            this._logger(false, this._logPrefix, `Event '${eventType}' has no listeners yet, ` +
                                               `caching emit of this event (cached so far ${eventArray.length}/${this._cacheSize})`);
        }

        return hasListener;
    }

    on(event: string | symbol, listener: (...args: any[]) => void): this {
        this._eventEmitter.on(event, listener);
        this.fireCachedEvents(event);
        return this;
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/EventEmitterCached.ts
 **/